(() => {
  // Evita declarar 2x (ex.: se o ficheiro for incluído duas vezes)
  if (window.__CartNotificationDefined || customElements.get('cart-notification')) return;

  // Wrappers seguros para funções globais do Dawn
  const safeTrap = (el) => {
    try { if (typeof trapFocus === 'function') trapFocus(el); } catch (e) {}
  };
  const safeUntrap = (el) => {
    try { if (typeof removeTrapFocus === 'function') removeTrapFocus(el); } catch (e) {}
  };

  class CartNotification extends HTMLElement {
    constructor() {
      super();

      // Elementos principais
      this.notification = document.getElementById('cart-notification');
      this.header = document.querySelector('sticky-header'); // web component do Dawn
      this.onBodyClick = this.handleBodyClick.bind(this);

      // Se o HTML do pop-up não existir, sai silenciosamente
      if (!this.notification) {
        console.warn('[cart-notification] #cart-notification não encontrado no DOM.');
        return;
      }

      // Fechar no ESC
      this.notification.addEventListener('keyup', (evt) => {
        if (evt.code === 'Escape') this.close();
      });

      // Botões de fechar dentro do componente
      this.querySelectorAll('button[type="button"]').forEach((btn) => {
        btn.addEventListener('click', this.close.bind(this));
      });
    }

    open() {
      if (!this.notification) return;

      this.notification.classList.add('animate', 'active');

      // dispara as animações toda vez que abrir
this.notification.classList.remove('is-animating');
void this.notification.offsetWidth;       // força reflow para reiniciar animações
this.notification.classList.add('is-animating');


      this.notification.addEventListener(
        'transitionend',
        () => {
          if (!this.notification) return;
          this.notification.focus();
          safeTrap(this.notification);
        },
        { once: true }
      );

      document.body.addEventListener('click', this.onBodyClick);
    }

    close() {
      if (!this.notification) return;

      this.notification.classList.remove('active');
      document.body.removeEventListener('click', this.onBodyClick);

      safeUntrap(this.activeElement);
    }

    renderContents(parsedState) {
      // parsedState pode vir string -> tenta converter
      if (parsedState && !parsedState.sections) {
        try { parsedState = JSON.parse(parsedState); } catch (e) {}
      }

      this.cartItemKey = parsedState?.key;

      this.getSectionsToRender().forEach((section) => {
        const container = document.getElementById(section.id);
        const html = parsedState?.sections?.[section.id];
        if (container && html) {
          container.innerHTML = this.getSectionInnerHTML(html, section.selector);
        }
      });

      if (this.header && typeof this.header.reveal === 'function') {
        this.header.reveal();
      }
      this.open();
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-product',
          selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
        },
        { id: 'cart-notification-button' },
        { id: 'cart-icon-bubble' },
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const el = doc.querySelector(selector) || doc.body;
      return el.innerHTML;
    }

    handleBodyClick(evt) {
      if (!this.notification) return;

      const target = evt.target;
      if (target !== this.notification && !target.closest('cart-notification')) {
        const disclosure = target.closest('details-disclosure, header-menu');
        this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
        this.close();
      }
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-notification', CartNotification);
  window.__CartNotificationDefined = true; // flag anti-duplicação
})();
